import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { adjustUTCToLocalTime } from '@utils/dates/dateMethods';

const IdahoFooter = props => {

    const {
        environment: {
            devEnvironment,
            exchangeName,
            buildNumber,
            buildDate,
            links: {
                PRIVACY_POLICY,
                SIGNUP_AGENCY,
                SIGNUP_AGENT_BROKER,
                SIGNUP_ENROLLMENT_ENTITIES
            },
            localDates: {
                timezoneOffsetMs=0,
                dstSavingsMs=0,
                serverDateInUTC,
                timezone,
            },
            user
        },
    } = props;

    const src = global.__ENV__.PRODUCTION ? '/hix/resources/img/logo_id_white.png' : '/assets/images/logo_id_white.png';


    const { sDate, sTime } = adjustUTCToLocalTime(serverDateInUTC, timezoneOffsetMs, dstSavingsMs);

    return (
        <Fragment>
            <footer id="footer--id" className="usa-footer" role="contentinfo">
                <div className="usa-footer-primary-section gi-footer__container">
                    <div className="usa-grid usa-footer__primary-section gi-footer__primary-section">
                        <div className="usa-footer__logo grid-row idaho-gap desktop:grid-col-12 tablet:grid-col-6 mobile-lg:grid-col-4 mobile-lg:grid-gap-2">
                            <div className="desktop-lg:grid-col-6 tablet-lg:grid-col-6 mobile-lg:grid-col-6">
                                <a href='#' className="gi-footer__image">
                                    <img src={src} alt={exchangeName} />
                                </a>
                                <div className="gi-footer__info" id="copyrights">
                                    <FormattedMessage id='footer.copyright' values={{ date: (new Date().getFullYear()) }}/>
                                </div>
                                <div className="gi-footer__info" id="privacy-policy">
                                    <a href={ PRIVACY_POLICY } target="_blank" rel="noreferrer noopener" id='privacy-policy'>
                                        <FormattedMessage id='footer.privacy_policy' />
                                    </a>
                                </div>
                            </div>
                            <div className="desktop-lg:grid-col-6 tablet-lg:grid-col-6 mobile-lg:grid-col-6 hidden">
                                <div className="gi-footer__info"><FormattedMessage id='footer.build_number' values={{ buildNumber: buildNumber }}/></div>
                                <div className="gi-footer__info"><FormattedMessage id='footer.build_date' values={{ buildDate: buildDate }}/></div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    devEnvironment &&
                    <div className="gi-footer__dev-container">
                        <div className="gi-footer__dev-section">
                            <div className="gi-footer__info gi-footer__info-heading">Dev Footer</div>
                            {
                                !user && ( <Fragment>
                                    <a className="gi-footer__link" href={SIGNUP_AGENCY}><FormattedMessage id='footer.agency' /></a>
                                    <a className="gi-footer__link" href={SIGNUP_AGENT_BROKER}><FormattedMessage id='footer.agent_broker' /></a>
                                    <a className="gi-footer__link" href={SIGNUP_ENROLLMENT_ENTITIES}><FormattedMessage id='footer.enrollment_entities' /></a>
                                </Fragment>)
                            }
                            <div className="gi-footer__info"><FormattedMessage id='footer.server_date' values={{ date: sDate }}/></div>
                            <div className="gi-footer__info"><FormattedMessage id='footer.server_time' values={{ time: `${sTime} ${timezone}` }}/></div>
                        </div>
                    </div>
                }
            </footer>
        </Fragment>

    );
};

export default IdahoFooter;
